module.exports = __webpack_public_path__ + "img/bn.a9afa812.svg";